export default "__VITE_ASSET__CFTaZmWi__"